import { render, staticRenderFns } from "./myinfo-usertype.vue?vue&type=template&id=22188e91&"
import script from "./myinfo-usertype.vue?vue&type=script&lang=js&"
export * from "./myinfo-usertype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports